@layer module {
.auth-shell {
            grid-row: 1 / 4;
            grid-column: left-column / right-column;
            min-height: 100vh;
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            justify-content: center;
    }

.auth-shell-split {
            display: grid;
            align-items: stretch;
            justify-content: stretch;
    }

.auth-pane {
            min-height: 100vh;
            display: flex;
            flex-direction: column;
    }

.auth-pane-header,
.auth-pane-body,
.auth-footer {
            width: 100%;
    }

.auth-pane-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
    }

.auth-pane-body {
            flex: 1 0 auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
    }

.auth-footer {
            display: flex;
            flex-wrap: wrap;
    }

.auth-container {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
    }

.auth-container :global(.err-msg-wrapper) {
            display: flex;
            justify-content: center;
    }

.auth-surface {
            width: 92vw;
    }

.auth-form {
            width: 100%;
            display: flex;
            flex-direction: column;
    }

.auth-language-menu {
            position: absolute;
    }

.auth-language-menu.auth-language-menu-inline {
            position: static;
    }

.auth-prompt {
            text-align: center;
    }

.auth-prompt a {
            text-decoration: none;
    }

      @media (min-width: 1024px) {

                .auth-shell-split > .auth-pane {
                        grid-column: 2;
                    }

                .auth-shell-split > :global(.auth-showcase) {
                        grid-column: 1;
                        grid-row: 1;
                    }
          }

      @media (max-width: 1023px) {

                .auth-shell-split .auth-pane-body {
                        flex: 0 0 auto;
                    }
          }
} // layer module










@layer app {
.auth-shell {
            padding: $size-100 $size-20 0;
    }

.auth-shell-split {
            padding: 0;
            grid-template-columns: minmax(0, 1fr);
    }

.auth-pane {
            padding: $size-32 $size-24;
    }

.auth-pane-header,
.auth-pane-body,
.auth-footer {
            max-width: $size-520;
            margin-inline: auto;
    }

.auth-pane-header {
            gap: $size-20;
    }

.auth-pane-body {
            padding: clamp($size-8, 3vh, $size-60) 0;
    }

.auth-pane .auth-subtitle {
            margin: $size-neg-4 0 $size-36;
    }

.auth-footer {
            gap: $size-8 $size-24;
    }

.auth-container {
            padding: 0 0 $size-65;
    }

.auth-surface {
            max-width: $size-500;
            padding: $size-20;
    }

.auth-title {
            margin-bottom: $size-30;
    }

.auth-title.auth-title-compact {
            margin-bottom: $size-20;
    }

.auth-title.auth-title-display {
            margin-bottom: $size-12;
    }

.auth-subtitle {
            margin-top: $size-10;
    }

.auth-language-menu {
            right: $size-50;
            top: $size-30;
    }

.auth-prompt {
            margin-top: $size-30;
    }

      @media (min-width: 450px) {
                .auth-surface {
                        padding: $size-40 $size-50;
                    }
          }

      @media (min-width: 950px) {
                .auth-shell {
                        padding: $size-70 $size-20 0;
                    }
                .auth-shell-split {
                        padding: 0;
                    }
                .auth-pane {
                        padding: $size-48 $size-64 $size-40;
                    }
          }

      @media (min-width: 1024px) {
                .auth-shell-split {
                        grid-template-columns: 7fr minmax($size-480, 5fr);
                    }
          }

      @media (max-width: 1023px) {
                .auth-shell-split .auth-pane {
                        gap: $size-24;
                    }
                .auth-shell-split .auth-pane-body {
                        margin-block: auto;
                        padding: $size-32 $size-24;
                    }
          }

.auth-shell {
            background-color: var(--auth-shell-background);
            background-image: url('@images/banky_bg.jpg');
            background-position: $size-neg-100 bottom;
            background-repeat: no-repeat;
            background-size: cover;
    }

.auth-shell-split {
            background-color: var(--auth-pane-background);
            background-image: none;
    }

.auth-surface {
            color: var(--text-primary);
            font-size: var(--font-size-xl);
            font-style: normal;
            font-weight: 400;
            line-height: $size-24;
    }

.auth-title {
            color: var(--text-primary);
            font-size: var(--font-size-xl);
            font-style: normal;
            font-weight: 400;
            line-height: $size-28;
    }

.auth-title.auth-title-compact {
            font-size: var(--font-size-xl);
            line-height: $size-24;
    }

.auth-title.auth-title-display {
            font-size: var(--font-size-4xl);
            font-weight: 500;
            line-height: $size-52;
            letter-spacing: -0.02em;
    }

.auth-subtitle {
            font-size: var(--font-size-base);
            font-weight: 400;
            line-height: $size-17;
    }

.auth-pane .auth-subtitle {
            color: var(--text-secondary);
            font-size: var(--font-size-lg);
            line-height: $size-24;
    }

.auth-footer {
            color: var(--text-secondary);
            font-size: var(--font-size-base);
            line-height: $size-16;
    }

.auth-footer a {
            color: inherit;
            text-decoration: none;
    }

.auth-footer a:hover {
            color: var(--text-primary);
    }

.auth-form a {
            color: var(--text-link);
    }

.auth-prompt {
            color: var(--auth-prompt-text);
            font-size: var(--font-size-base);
            font-weight: 400;
            line-height: $size-17;
    }

.auth-prompt a {
            color: var(--auth-prompt-text);
            font-weight: 700;
    }

      @media (min-width: 1024px) {
                .auth-shell {
                        background-position: center bottom;
                    }
          }

      @media (max-width: 1023px) {
                .auth-shell-split {
                        background-color: var(--auth-shell-background);
                    }

                .auth-shell-split .auth-pane-body {
                        border-radius: $size-16;
                        background-color: var(--auth-pane-background);
                        box-shadow: var(--shadow-card);
                    }

                .auth-shell-split .auth-footer {
                        color: var(--auth-showcase-muted-text);
                    }

                :where(.auth-shell-split) .auth-footer a:hover {
                        color: var(--auth-showcase-text);
                    }
          }
} // layer app










@layer context {
      @media (max-width: 949px) {
                .auth-shell:global(.set-password-wrapper) {
                        padding: $size-20 0 $size-100;
                    }
          }
} // layer context
